(function () {

    jQuery('[rel="js-scroll-to-anchor"]').on('click', event => {
        event.preventDefault();

        const element = jQuery(event.target.getAttribute('href'));

        jQuery('html, body').animate({
            scrollTop: element.offset().top - 30,
        }, 400, 'swing', () => {
            window.history.replaceState({}, document.title, event.target.getAttribute('href'))

        });
    });

    const expander = jQuery('[rel="js-expand-index"]');
    const minimiser = jQuery('[rel="js-minimise-index"]');
    const pageIndex = jQuery('[rel="js-page-index"]');

    minimiser.on('click', () => {
        minimiser.hide();
        expander.show();
        pageIndex.hide();
    });

    expander.on('click', () => {
        minimiser.show();
        expander.hide();
        pageIndex.show();
    });

    if (window.innerWidth < 576) {
        minimiser.hide();
        expander.show();
        pageIndex.hide();
    }
})();



// WEBPACK FOOTER //
// ./web/app/themes/giles/resources/js/components/page-index.js